module.exports = __webpack_public_path__ + "media/conversa/bannerConversaModal-66c08fad.png";